

export class UserGroupStatusInput implements IUserGroupStatusInput {
    /** The auto-generated id of the user group master */
    userGroupId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IUserGroupStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userGroupId = _data["userGroupId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UserGroupStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userGroupId"] = this.userGroupId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IUserGroupStatusInput {
    /** The auto-generated id of the user group master */
    userGroupId: number;
    /** The updated status */
    status: number;
}

